import {css, useTheme} from '@mui/material';
import * as React from 'react';
import {Collapse} from 'react-bootstrap';
import {GetStylesFunction} from 'src/js/common/types';
import {HierarchyTreeNode} from 'src/js/model/hierarchy_tree_children';

import {HierarchySyncNodeContainer} from './HierarchySyncNodeContainer';

interface OwnProps {
  hierarchyId: string | number;
  hierarchyChildren?: HierarchyTreeNode[];
  isOpened?: boolean;
  isTogglingSeparated?: boolean;
  level?: number;
  srcNodeClick?: (node: HierarchyTreeNode) => void;
  tabIndex?: number;
  highlightedValues?: string[];
  getOptionDisabled?: (row: any) => boolean;
}

type Props = OwnProps;

export const HierarchySyncNodeChildren: React.FC<Props> = (props) => {
  const {
    hierarchyChildren = [],
    hierarchyId,
    isOpened = false,
    isTogglingSeparated = false,
    level = 0,
    srcNodeClick,
    tabIndex = 0,
    highlightedValues,
    getOptionDisabled,
  } = props;

  const theme = useTheme();
  const styles = getStyles({theme});

  return (
    <div data-name={'hierarchy-sync-node-children--wrapper'}>
      <ul
        data-name={'hierarchy-sync-node-children--ul'}
        css={styles.dlHierarchySyncNodeChildren}
      >
        {hierarchyChildren?.length > 0
          ? hierarchyChildren.map((childNode) => (
              <Collapse in={isOpened} key={childNode.getId()}>
                <div
                  data-name={'hierarchy-sync-node-children--container-wrapper'}
                >
                  {isOpened && (
                    <HierarchySyncNodeContainer
                      hierarchyId={hierarchyId}
                      isTogglingSeparated={isTogglingSeparated}
                      node={childNode}
                      onNodeClick={srcNodeClick}
                      level={level + 1}
                      tabIndex={tabIndex}
                      highlightedValues={highlightedValues}
                      getOptionDisabled={getOptionDisabled}
                    />
                  )}
                </div>
              </Collapse>
            ))
          : null}
      </ul>
    </div>
  );
};

HierarchySyncNodeChildren.displayName = 'HierarchySyncNodeChildren';

const getStyles: GetStylesFunction = (_options) => ({
  dlHierarchySyncNodeChildren: css`
    overflow: hidden;
    border-left: 1px solid #4d5358;
    padding-left: 6px;
    margin-left: 8px;
  `,
});
